module.exports = __webpack_public_path__ + "static/media/logo-white.ac359241.png";